import { useState } from "react";
import dayjs from 'dayjs';
import { useTranslation } from "react-i18next";
import CalendarTimePicker from "./CalendarTimePicker";
import CalendarDatePicker from "./CalendarDatePicker";

const EventRescheduleModal = ({ eventDetails, setShowRescheduleViewModal }) => {
    const { t } = useTranslation();

    const [showType, setShowType] = useState(false);
    const [showKindType, setShowKindType] = useState(false);
    const [appointmentType, setAppointmentType] = useState("");
    const [appointmentKindType, setAppointmentKindType] = useState("");

    const handleShowCreateModal = (e) => {
        e.preventDefault();
        setShowRescheduleViewModal()
    };
    const handleAppointmentType = (e, data) => {
        e.preventDefault();
        setAppointmentType(data);
    };
    const handleAppointmentKindType = (e, data) => {
        e.preventDefault();
        setAppointmentKindType(data);
    };
    const handleDateDataFromChild = (data) => {

    };

    return (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex justify-center items-end sm:items-center z-50">
            <div className="bg-white  rounded-t-lg sm:rounded-lg shadow-lg w-[34rem] p-2.5 sm:p-6 space-y-2 sm:space-y-4">
                <div className="flex justify-between items-center">
                    <div className='flex items-center space-x-2'>
                        <h3 className="text-lg font-semibold capitalize">
                            { t('reschedule appointment')}
                        </h3>
                    </div>
                    <button onClick={(e) => handleShowCreateModal(e)} className="text-gray-500 hover:text-gray-700">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"/>
                        </svg>
                    </button>
                </div>
                <div className='space-y-2'>
                    <div className='grid grid-cols-2 gap-2'>
                        <div className="space-y-1">
                            <div className='flex items-start space-x-2'>
                                <label className='text-xs sm:text-sm capitalize text-light-700'>{t('appointment date')}</label>
                            </div>
                            <div className='flex justify-between text-xs sm:text-sm bg-white border border-background-normal rounded-md px-4 py-3 sm:py-2.5'>
                                <CalendarDatePicker setDataFromChild={handleDateDataFromChild} startDate={dayjs()} dateInput={dayjs()} name={'date'}/>
                            </div>
                        </div>
                        <div className="space-y-1">
                            <div className='flex items-start space-x-2'>
                                <label className='text-xs sm:text-sm capitalize text-light-700'>{t('appointment time')}</label>
                            </div>
                            <div className='flex justify-between text-xs sm:text-sm bg-white border border-background-normal rounded-md px-4 py-2.5'>
                                <CalendarTimePicker startDateTime={eventDetails.start} endDateTime={eventDetails.end} />
                            </div>
                        </div>
                        <div className="space-y-1">
                            <div className='flex items-start space-x-2'>
                                <label className='text-xs sm:text-sm capitalize text-light-700'>{t('appointment type')}</label>
                            </div>
                            <div className='text-sm bg-white border border-background-normal rounded-md px-4 py-2 relative'>
                                <button type="button" onClick={(e) => setShowType(!showType)} className="flex justify-between items-center w-full">
                                    <span className={`mr-1 text-xs sm:text-sm capitalize ${appointmentType ? "text-black" : "text-gray-dark"}`}>
                                        {appointmentType || t("select")}
                                    </span>
                                    <img src="../../assets/icons/select-down.svg" alt="select-down" />
                                </button>
                                {showType && (
                                    <ul className="absolute left-0 w-full overflow-y-auto no-scrollbar z-10 text-background-dark bg-white shadow-md rounded-md top-10">
                                        <li key="state" onClick={(e) => handleAppointmentType(e, "")} className="cursor-pointer bg-white hover:bg-action-hover px-3 py-2 block whitespace-no-wrap capitalize text-xs sm:text-sm">
                                            {t("select")}
                                        </li>
                                    </ul>
                                )}
                            </div>
                        </div>
                        <div className="space-y-1">
                            <div className='flex items-start space-x-2'>
                                <label className='text-xs sm:text-sm capitalize text-light-700'>{t('kind of appointment type')}</label>
                            </div>
                            <div className='text-sm bg-white border border-background-normal rounded-md px-4 py-2 relative'>
                                <button type="button" onClick={(e) => setShowKindType(!showKindType)} className="flex justify-between items-center w-full">
                                    <span className={`mr-1 text-xs sm:text-sm capitalize ${appointmentKindType ? "text-black" : "text-gray-dark"}`}>
                                        {appointmentType || t("select")}
                                    </span>
                                    <img src="../../assets/icons/select-down.svg" alt="select-down" />
                                </button>
                                {showKindType && (
                                    <ul className="absolute left-0 w-full overflow-y-auto no-scrollbar z-10 text-background-dark bg-white shadow-md rounded-md top-10">
                                        <li key="state" onClick={(e) => handleAppointmentKindType(e, "")} className="cursor-pointer bg-white hover:bg-action-hover px-3 py-2 block whitespace-no-wrap capitalize text-xs sm:text-sm">
                                            {t("select")}
                                        </li>
                                    </ul>
                                )}
                            </div>
                        </div>
                    </div>
                    <textarea className="bg-white border border-background-normal rounded-md px-4 py-2 w-full relative flex items-start focus:outline-none" rows={3} columns={10} placeholder={ t("write comments here...")}></textarea>
                </div>
                <div className="flex justify-between items-center text-sm sm:text-base">
                    <button onClick={(e) => handleShowCreateModal(e)} className="px-4 py-2 bg-white text-gray-dark4 capitalize font-medium border-2 border-background-normal rounded-lg">
                        { t('close')}
                    </button>
                    <button className="px-4 py-2 bg-blue-normal text-white rounded-lg capitalize">
                        { t('reschedule appointment')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default EventRescheduleModal;
